import { broadcastAuthLogout, clearAuthStorage, getAuthToken } from './authStorage';

const safeAtob = (value) => {
  try {
    return atob(value);
  } catch {
    try {
      return Buffer.from(value, 'base64').toString('binary');
    } catch {
      return null;
    }
  }
};

const decodeTokenExp = (token) => {
  if (!token) return null;
  const parts = token.split('.');
  if (parts.length < 2) return null;
  try {
    const payloadStr = safeAtob(parts[1].replace(/-/g, '+').replace(/_/g, '/'));
    if (!payloadStr) return null;
    const payload = JSON.parse(payloadStr);
    if (typeof payload.exp !== 'number') return null;
    return payload.exp;
  } catch {
    return null;
  }
};

export const isTokenExpired = (token, skewSeconds = 30) => {
  const exp = decodeTokenExp(token);
  if (!exp) return false;
  const now = Math.floor(Date.now() / 1000);
  return exp <= now + skewSeconds;
};

export const AUTH_SESSION_EXPIRED_EVENT = 'auth:session-expired';

const safeText = (value) => (typeof value === 'string' ? value.trim() : '');

const getCurrentPath = () => {
  if (typeof window === 'undefined') return '/';
  try {
    const { pathname, search, hash } = window.location;
    return `${pathname || ''}${search || ''}${hash || ''}` || '/';
  } catch {
    return '/';
  }
};

export const emitAuthSessionExpired = ({
  message = '登录已失效，请重新登录',
  from,
  requiredRole,
} = {}) => {
  if (typeof window === 'undefined') return;
  const detail = {
    message: safeText(message) || '登录已失效，请重新登录',
    from: safeText(from) || getCurrentPath(),
    requiredRole: safeText(requiredRole),
  };
  try {
    window.dispatchEvent(new CustomEvent(AUTH_SESSION_EXPIRED_EVENT, { detail }));
  } catch {}
};

export const clearAuth = (client) => {
  clearAuthStorage();
  if (client?.defaults?.headers?.common) {
    try {
      delete client.defaults.headers.common['Authorization'];
    } catch {}
  }
  broadcastAuthLogout();
  try {
    window.dispatchEvent(new CustomEvent('auth:changed', { detail: { isLoggedIn: false } }));
  } catch {}
};

export const ensureFreshAuth = (client) => {
  const token = getAuthToken();

  if (!token) {
    return { token: null, expired: false };
  }

  const expired = isTokenExpired(token);
  if (expired) {
    return { token, expired: true };
  }

  if (client?.defaults?.headers?.common) {
    try {
      client.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } catch {}
  }
  return { token, expired: false };
};
